export namespace KontaktverwaltungEntityTypes {
    export const KONTAKT_ENTITY = 'KONTAKTVERW.KONTAKT';
    export const KONTAKT_ENTITY_PART_AKTIV = 'AKTIV';
    export const KONTAKT_ENTITY_PART_EXTERN = 'EXTERN';
    export const KONTAKT_ENTITY_PART_TELEFONE = 'TELEFONE';
    export const KONTAKT_TELEFON_ENTITY = 'KONTAKTVERW.KONTAKTTELEFON';
    
}

